/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, { Component } from 'react';

import withEhsPageBehavior from '../../withEhsPageBehavior';
import { history } from '../../state/store';

import PracticeDetails from './PracticeDetails';
import OrganizationApi from '../../api/organization';

import PracticeList from './PracticeList';
import Subnav from '../subnav';

class ManagePracticesPage extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            practices: [],
            selected: null,
        };

        this.loadPractices = this.loadPractices.bind(this);
        this.patchPractice = this.patchPractice.bind(this);
        this.selectPractice = this.selectPractice.bind(this);
    }

    componentDidMount() {
        this.loadPractices();
        this.selectPractice();
    }

    loadPractices() {
        const orgId = this.props.match.params.organizationId;
        OrganizationApi.getPractices(orgId)
            .then(practices => {
                let selected = null;
                if (practices && practices.length >= 1) {
                    selected = practices[0];
                }

                this.setState({ practices: practices, selected: selected });
            })
            .catch(errorMessage => {
                console.log('Error: ' + errorMessage);
            });
    }

    patchPractice(practice) {
        let practices = this.state.practices;
        let idx = -1;
        practices.forEach((p, i) => {
            if (p.id === practice.id) {
                idx = i;
            }
        });
        let newPractices = this.state.practices.slice(0); // clone array
        if (idx >= 0) {
            newPractices[idx] = practice;
        }
        this.setState({ practices: newPractices });
    }

    selectPractice(practice) {
        this.setState({ selected: practice });
    }

    render() {
        const { practices, selected } = this.state;
        const organizationId = this.props.match.params.organizationId;

        const loading = (
          <div>
            <i className="fa fa-circle-o-notch m2spin" /> Loading Practices...
          </div>
        );

        return (
          <div className="page">
            <div className="page__subnav">
              <Subnav organizationId={organizationId} />
            </div>
            <div className="masterdetailspage">
              <div className="masterdetailspage__master">
                <h2>
                  <i className="fa fa-sitemap"></i> Practices
                </h2>
                {practices.length === 0 && loading}
                <PracticeList
                  practices={practices}
                  selected={selected}
                  onSelection={this.selectPractice}
                />

                <a
                  className=""
                  onClick={() => {
                    history.push(
                      `/organization/${organizationId}/practices/new`
                    );
                  }}>
                  <i className="fa fa-plus"></i>
                  &nbsp; Add a new practice
                </a>
              </div>
              <div className="masterdetailspage__details">
                <PracticeDetails
                  practice={selected}
                  onDelete={this.loadPractices}
                  onUpdate={this.patchPractice}
                />
              </div>
            </div>
          </div>
        );
    }
}

export default withEhsPageBehavior(ManagePracticesPage);
